"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Mobile_1 = __importDefault(require("./FullStructuredContentFooter/Mobile"));

var Desktop_1 = __importDefault(require("./FullStructuredContentFooter/Desktop"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_application_1 = require("@ryerson/frontend.application");

var Constants_1 = require("../common/Constants");

var SimpleFooter_1 = __importDefault(require("./SimpleFooter"));

var styled_1 = __importDefault(require("@emotion/styled"));

var FooterContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t.simple-footer {\n\t\tdisplay: none;\n\t}\n\n\t@media print {\n\t\t.footer-desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.footer-mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.simple-footer {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"])));

var FullFooter = function FullFooter(_ref) {
  var companyName = _ref.companyName,
      footerData = _ref.footerData,
      _ref$storeDirectory = _ref.storeDirectory,
      storeDirectory = _ref$storeDirectory === void 0 ? Constants_1.STORE : _ref$storeDirectory;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      _ref2$user = _ref2.user,
      isLoggedIn = _ref2$user.isLoggedIn,
      token = _ref2$user.token;

  return (0, jsx_runtime_1.jsxs)(FooterContainer, {
    children: [(0, jsx_runtime_1.jsx)(SimpleFooter_1.default, {
      companyName: companyName,
      storeDirectory: storeDirectory
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsx)(Mobile_1.default, {
        companyName: companyName,
        storeDirectory: storeDirectory,
        footerData: footerData
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsx)(Desktop_1.default, {
        companyName: companyName,
        storeDirectory: storeDirectory,
        footerData: footerData,
        isLoggedIn: isLoggedIn,
        token: token
      })
    })]
  });
};

exports.default = FullFooter;